import { render, staticRenderFns } from "./cargoDepartmentNewSelect.vue?vue&type=template&id=b12ea540&"
import script from "./cargoDepartmentNewSelect.vue?vue&type=script&lang=js&"
export * from "./cargoDepartmentNewSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b12ea540')) {
      api.createRecord('b12ea540', component.options)
    } else {
      api.reload('b12ea540', component.options)
    }
    module.hot.accept("./cargoDepartmentNewSelect.vue?vue&type=template&id=b12ea540&", function () {
      api.rerender('b12ea540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/standard/cargoDepartmentNewSelect.vue"
export default component.exports